import { Injectable } from '@angular/core';
import { GuardResult, RedirectCommand, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { UserService } from '../shared/services/user.service';

/**
 * Bramka panelu administratora serwisu (/admin). Pyta backend o /user/me
 * i wpuszcza tylko konta z flagą is_site_admin - poziomy uprawnień w drzewach
 * nie mają tu nic do rzeczy.
 *
 * canMatch, nie canLoad - patrz komentarz w TreeSettingsGuard: canLoad po
 * zbuforowaniu modułu przestaje być sprawdzany.
 */
@Injectable({
  providedIn: 'root'
})
export class SiteAdminGuard {

  constructor(private router: Router, private userService: UserService) { }

  canMatch(): Observable<GuardResult> {
    const home = this.router.createUrlTree(['/']);
    return this.userService.getCurrentUser().pipe(
      map((user) => user?.is_site_admin === true
        ? true
        : new RedirectCommand(home, { skipLocationChange: false })),
      // 403 (niezalogowany) i inne błędy - po prostu na stronę główną
      catchError(() => of(new RedirectCommand(home, { skipLocationChange: false })))
    );
  }
}
